import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalizedTimeRangeFormatPipe } from '@wilson/localization';
import {
  areIntervalsOverlapping,
  endOfDay,
  isWithinInterval,
  max,
  min,
  startOfDay,
} from 'date-fns';

@Pipe({
  name: 'timeInterval',
  standalone: false,
})
export class TimeIntervalPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);
  private readonly localizedTimeRangeFormat = inject(
    LocalizedTimeRangeFormatPipe,
  );

  transform(interval: Interval, dateToCompare: Date): string {
    const isAllDay = this.isAllDay(interval, dateToCompare);
    if (isAllDay) return this.translate.instant('general.all_day');

    const transformedInterval = this.transformWithDateToCompare(
      interval,
      dateToCompare,
    );
    return transformedInterval
      ? this.localizedTimeRangeFormat.transform(transformedInterval)
      : '';
  }

  isAllDay(interval: Interval, dateToCompare: Date): boolean {
    return (
      isWithinInterval(startOfDay(dateToCompare), interval) &&
      isWithinInterval(endOfDay(dateToCompare), interval)
    );
  }

  private transformWithDateToCompare(
    interval: Interval,
    dateToCompare: Date,
  ): Interval | null {
    const dateToCompareInterval = {
      start: startOfDay(dateToCompare),
      end: endOfDay(dateToCompare),
    };

    if (areIntervalsOverlapping(interval, dateToCompareInterval)) {
      const start = max([interval.start, dateToCompareInterval.start]);
      const end = min([interval.end, dateToCompareInterval.end]);
      return { start, end };
    }

    return null;
  }
}
